export const Payments = () => {
  return <div>This is payments page.</div>;
};
